module.exports = __webpack_public_path__ + "static/media/1073.5238ddcb.jpg";